import { h } from "preact";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import palette from "./palette";
import WhiteTextTypography from "./WhiteTextTypography";

const WhiteLink = (props) => {
	return <WhiteTextTypography {...props} style="margin-right: 10px, color: white" />;
};

export default WhiteLink;
